const FilterSearch = function() {
    function FilterSearch() {
        this.selector = {
            main: document.getElementById('glFilter-search-popup'),
            desktop_header: document.getElementById('toolbar-item-search-desktop'),
            desktop_search_header_close: document.getElementById('desktop-search-header-close'),
            searchbox_input: document.getElementById('gl-d-searchbox-input'),
            pre_added_search_products: document.getElementById('pre-added-search-products-content'),
            search_result_added_products: document.getElementById('search-results-products-content'),
            pre_added_suggestion_products: document.getElementById('pre-added-suggestion-products'),
            search_suggestion_products: document.getElementById('search-suggestion-products'),
            search_suggestion_collections: document.getElementById('search-suggestion-collections'),
            search_suggestion_pages: document.getElementById('search-suggestion-pages'),
            search_suggestion_blog_posts: document.getElementById('search-suggestion-blog-posts'),
            search_result_list_url: document.getElementById('search-result-list-url'),
            search_result_list_title: document.getElementById('search-result-list-title'),
            toolbar_item_search_mobile: document.getElementById('toolbar-item-search-mobile'),
            search_auto_complete: document.getElementById('search-auto-complete'),
            convx__search_input: document.getElementById('convx__search-form-input'),
            mobile_search_auto_complete: document.getElementById('mobile-search-auto-complete'),
            mobile_nav_wrapper: document.querySelector('.mobile-nav-wrapper'),
            search_no_results: document.getElementById('search-no-results'),
            search_no_results_term: document.getElementById('search-no-results-term'),
            search_default_row: document.getElementById('search-default-row'),
            search_view_all_bottom: document.getElementById('search-view-all-bottom'),
            search_view_all_count: document.getElementById('search-view-all-count')
        }
        this.state = {
            typingTimer: null,
            reqSeq: 0,
            searchController: null
        }
        this.load();
    }
    FilterSearch.prototype.load = function() {
        var _ = this;
        if(_.selector.desktop_header) {
            _.selector.desktop_header.addEventListener('click', () => {
                _.selector.main.classList.add('active');
                document.body.classList.add('gl-search-open');
            });
        };
        if(_.selector.desktop_search_header_close) {
            _.selector.desktop_search_header_close.addEventListener('click', () => {
                _.selector.main.classList.remove('active');
                document.body.classList.remove('gl-search-open');
            })
        };
        if(_.selector.searchbox_input) {
            _.selector.searchbox_input.addEventListener('keyup', event => {
                /* T5.77 — Search-as-you-type: updates on EVERY keystroke (no debounce, kept live
                   per Warwick). The anti-bounce fix is the stale-response guard in searchkeyword()
                   (only the newest response is ever painted), NOT a debounce. Skip navigation/
                   modifier keys so arrows/enter/shift don't re-fire. Results fire from the FIRST
                   letter; only an empty box resets to the curated state with no network call
                   (change `< 1` to `< 2` if you ever want to skip single-letter searches). */
                if (['ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Enter','Shift','Control','Alt','Meta','Tab'].indexOf(event.key) !== -1) return;
                var value = event.target.value;
                _.searchkeyword(value.trim().length < 1 ? '' : value);
            })
        };
        /* Overlay → results page: append a trailing "*" on Enter/submit so the FULL results page runs
           the same wildcard search the dropdown showed. Typing "liop" and hitting Enter used to go to
           /search?q=liop (plain) = 0 results; now it goes to /search?q=liop* = matches. Also strip any
           "*" a wildcard results URL left in the pre-filled box so it can't compound into "liop**". */
        var glSearchForm = document.querySelector('.gl-d-searchbox');
        if (glSearchForm && _.selector.searchbox_input) {
            if (_.selector.searchbox_input.value) {
                _.selector.searchbox_input.value = _.selector.searchbox_input.value.replace(/\*+$/, '');
            }
            glSearchForm.addEventListener('submit', function () {
                var v = _.selector.searchbox_input.value.trim().replace(/\*+$/, '');
                _.selector.searchbox_input.value = v ? v + '*' : v;
            });
        }
        if(_.selector.convx__search_input) {
            _.selector.convx__search_input.addEventListener('keyup', event => {
                /* T5.77 — Search-as-you-type for the mobile path (same key guard + min-length, no debounce). */
                if (['ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Enter','Shift','Control','Alt','Meta','Tab'].indexOf(event.key) !== -1) return;
                var value = event.target.value;
                _.mobilesearchkeyword(value.trim().length < 1 ? '' : value);
            })
        }
        if(_.selector.toolbar_item_search_mobile) {
            _.selector.toolbar_item_search_mobile.addEventListener('click', event => {
                event.preventDefault();
                _.selector.main.classList.add('active');
                document.body.classList.add('gl-search-open');
            });
        };
        if(_.selector.search_auto_complete) {
            _.selector.search_auto_complete.addEventListener('mouseleave', () => {
                _.selector.search_auto_complete.classList.remove('active');
            })
        }
        /* No mouseleave-to-close on the mobile nav-drawer search dropdown — on touch, scrolling fires a
           synthetic mouseleave that closed it mid-scroll before you could tap an option. It still closes
           by tapping outside it (the mobile_nav_wrapper handler below), clearing the box, or picking a
           result. */
        if(_.selector.mobile_nav_wrapper) {
            _.selector.mobile_nav_wrapper.addEventListener('click', event => {
                if(!event.target.closest('.mobile-search-auto-complete')) {
                    _.selector.mobile_search_auto_complete.classList.remove('active');
                }
            })
        }
        if(_.selector.main) {
            _.selector.main.addEventListener('click', event => {
                if(!event.target.closest('.search-auto-complete')) {
                    _.selector.search_auto_complete.classList.remove('active');
                }
            })
        }
    }
    FilterSearch.prototype.startSearch = function() {
        if (this.state.searchController) this.state.searchController.abort();
        this.state.searchController = new AbortController();
        return {
            requestId: ++this.state.reqSeq,
            signal: this.state.searchController.signal
        };
    }
    FilterSearch.prototype.mobilesearchkeyword = async function(keyword) {
        var _ = this;
        var request = _.startSearch();
        var myReq = request.requestId;
        var box = _.selector.mobile_search_auto_complete;
        if (!box) return;
        var ul = box.querySelector('ul');
        /* Empty box → clear the list + hide. */
        if (keyword === "") {
            if (ul) ul.innerHTML = '';
            box.classList.remove('active');
            return;
        }
        await fetch(window.Shopify.routes.root + `search/suggest.json?q=${encodeURIComponent(keyword)}*&resources[options][unavailable_products]=hide&resources[limit]=5&resources[limit_scope]=each&prefix=last`, { signal: request.signal })
        .then((response) => response.json())
        .then((suggestions) => {
            if (myReq !== _.state.reqSeq) return;
            if (!ul) return;
            /* Always clear BEFORE repainting so a keystroke that matches nothing can't leave the
               PREVIOUS query's suggestions stuck on screen (the stale-list glitch). */
            ul.innerHTML = '';
            box.classList.remove('active');
            var results = suggestions.resources && suggestions.resources.results;
            if (!results) return;
            /* Text query suggestions first; when Shopify returns none (common on longer prefixes),
               fall back to the wildcard-matched product names so the list still updates every keystroke. */
            /* Audit D2 (11 Oct 2026): type=product on the suggestion link so the results count matches the product grid. */
            var items = (results.queries && results.queries.length > 0)
                ? results.queries.map(function (q) { return { text: q.text, url: '/search?q=' + encodeURIComponent(q.text) + '&type=product' }; })
                : (results.products || []).map(function (p) { return { text: p.title, url: p.url }; });
            if (!items.length) return;
            box.classList.add('active');
            items.forEach(function (item) {
                var li = document.createElement('li');
                li.innerHTML = `<a href="${item.url}">${item.text}<span class="count"></span></a>`;
                ul.append(li);
            });
        })
        .catch(error => {
            if (error.name !== 'AbortError' && myReq === _.state.reqSeq) console.error('Fetch request failed:', error);
        });
    }
    FilterSearch.prototype.searchkeyword = async function(keyword) {
        var _ = this;
        /* T5.77 — stale-response guard: if a newer search starts before this one's fetches
           resolve, skip painting so out-of-order responses can't overwrite newer results. */
        var request = _.startSearch();
        var myReq = request.requestId;
        /* Empty/too-short query: reset to the curated state with NO network call. */
        if (!keyword) {
            /* T5.79 — Restore the default row + hide the no-results banner when the box is emptied. */
            if (_.selector.search_no_results) _.selector.search_no_results.style.display = 'none';
            if (_.selector.search_default_row) _.selector.search_default_row.style.display = '';
            _.selector.pre_added_search_products.classList.add('active');
            _.selector.search_result_added_products.classList.remove('active');
            _.selector.search_result_list_url.classList.remove('active');
            _.selector.search_result_list_title.textContent = 'Trending Products';
            _.selector.search_result_added_products.innerHTML = '';
            if (_.selector.search_view_all_bottom) _.selector.search_view_all_bottom.style.display = 'none';
            _.selector.pre_added_suggestion_products.classList.add('active');
            _.selector.search_suggestion_products.classList.remove('active');
            _.selector.search_suggestion_products.querySelector('ul').innerHTML = '';
            _.selector.search_suggestion_collections.classList.remove('active');
            _.selector.search_suggestion_collections.querySelector('ul').innerHTML = '';
            _.selector.search_suggestion_pages.classList.remove('active');
            _.selector.search_suggestion_pages.querySelector('ul').innerHTML = '';
            _.selector.search_suggestion_blog_posts.classList.remove('active');
            _.selector.search_suggestion_blog_posts.querySelector('ul').innerHTML = '';
            _.selector.search_auto_complete.querySelector('ul').innerHTML = '';
            _.selector.search_auto_complete.classList.remove('active');
            return;
        }
        const section_url = `${window.Shopify.routes.root}search?section_id=popup-search-result&q=${encodeURIComponent(keyword)}*&type=product`;
        fetch(section_url, { signal: request.signal })
        .then(response => response.text())
        .then(html => {
            if (myReq !== _.state.reqSeq) return;
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(html, 'text/html');
            const gf_products = htmlDoc.getElementById('gf-products'); 
            if(gf_products) {
                if(parseInt(gf_products.dataset.searchResultCount) > 0) {
                    /* T5.79 — Results found: hide the no-results banner, restore the default row. */
                    if (_.selector.search_no_results) _.selector.search_no_results.style.display = 'none';
                    if (_.selector.search_default_row) _.selector.search_default_row.style.display = '';
                    _.selector.pre_added_search_products.classList.remove('active');
                    _.selector.search_result_added_products.classList.add('active');
                    _.selector.search_result_list_url.classList.add('active');
                    /* Audit D2 (11 Oct 2026): type=product, same as the preview request above, so the results page count matches the grid. */
                    _.selector.search_result_list_url.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(keyword)}*&type=product`;
                    _.selector.search_result_list_title.textContent = 'Products';
                    _.selector.search_result_added_products.innerHTML = gf_products.innerHTML;
                    /* Bottom "View all N results" CTA — show it ONLY when there are MORE matching
                       products than the preview already shows (else tapping it just reloads the same
                       set). Compare the total count to the cards rendered in the preview. */
                    if (_.selector.search_view_all_bottom) {
                        var _total = parseInt(gf_products.dataset.searchResultCount, 10) || 0;
                        var _shown = gf_products.querySelectorAll('.gl-card').length;
                        if (_total > _shown) {
                            _.selector.search_view_all_bottom.style.display = '';
                            /* Audit D2 (11 Oct 2026): type=product (see above). */
                            _.selector.search_view_all_bottom.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(keyword)}*&type=product`;
                            if (_.selector.search_view_all_count) _.selector.search_view_all_count.textContent = _total;
                        } else {
                            _.selector.search_view_all_bottom.style.display = 'none';
                        }
                    }
                } else {
                    /* T5.79 — No products matched: show an explicit no-results banner (message + Browse
                       the shop button + contact link) and hide the default two-column row, so only the
                       banner shows (instead of silently reverting to the Trending Products grid). */
                    if (_.selector.search_no_results_term) _.selector.search_no_results_term.textContent = keyword;
                    if (_.selector.search_no_results) _.selector.search_no_results.style.display = '';
                    if (_.selector.search_default_row) _.selector.search_default_row.style.display = 'none';
                    _.selector.pre_added_search_products.classList.remove('active');
                    _.selector.search_result_added_products.classList.remove('active');
                    _.selector.search_result_added_products.innerHTML = '';
                    if (_.selector.search_view_all_bottom) _.selector.search_view_all_bottom.style.display = 'none';
                }
            
            }
        })
        .catch(error => {
            if (error.name !== 'AbortError' && myReq === _.state.reqSeq) console.error('Fetch request failed:', error);
        });
        /* Autocomplete speed: the suggest.json request that fills this dropdown used to sit in the
           product-section fetch's .finally(), so it couldn't even START until the heavy product-grid
           HTML had downloaded + parsed. The product fetch above is now fire-and-forget and the
           suggestions run in PARALLEL, so the dropdown paints as soon as the lightweight suggest.json
           returns instead of trailing the slow grid. */
        await (async () => {
            if(keyword !== "") {
                await fetch(window.Shopify.routes.root + `search/suggest.json?q=${encodeURIComponent(keyword)}&resources[options][unavailable_products]=hide&resources[limit]=5&resources[limit_scope]=each&prefix=last`, { signal: request.signal })
                .then((response) => response.json())
                .then((suggestions) => {
                    if (myReq !== _.state.reqSeq) return;
                    /* T5.79 — Stale-left-column fix: reset ALL suggestion zones BEFORE repainting, so a
                       query that returns 0 collections/pages/blog no longer leaves the PREVIOUS query's
                       items on screen. Each if (length > 0) block below then re-fills only what THIS
                       query returned. */
                    /* Also drop the curated "Suggestions" (pre-added) list while a query is active, so a
                       query with zero suggestions leaves the left column genuinely empty — the desktop
                       CSS then collapses the empty white box instead of flickering it in and out. */
                    _.selector.pre_added_suggestion_products.classList.remove('active');
                    _.selector.search_suggestion_products.classList.remove('active');
                    _.selector.search_suggestion_products.querySelector('ul').innerHTML = '';
                    _.selector.search_suggestion_collections.classList.remove('active');
                    _.selector.search_suggestion_collections.querySelector('ul').innerHTML = '';
                    _.selector.search_suggestion_pages.classList.remove('active');
                    _.selector.search_suggestion_pages.querySelector('ul').innerHTML = '';
                    _.selector.search_suggestion_blog_posts.classList.remove('active');
                    _.selector.search_suggestion_blog_posts.querySelector('ul').innerHTML = '';
                    _.selector.search_auto_complete.classList.remove('active');
                    _.selector.search_auto_complete.querySelector('ul').innerHTML = '';
                    if(suggestions.resources) {
                        if(suggestions.resources.results.queries.length > 0) {
                            /* Populate the on-page "Suggestions" column. The old floating autocomplete
                               bar (search-auto-complete) is intentionally no longer activated/filled —
                               on desktop it vanished on hover and covered this column. Appending the
                               <li> to BOTH lists also MOVED the node (append relocates it), which left
                               this column empty. Now it stays here. */
                            _.selector.pre_added_suggestion_products.classList.remove('active');
                            _.selector.search_suggestion_products.classList.add('active');
                            _.selector.search_suggestion_products.querySelector('ul').innerHTML = '';
                            suggestions.resources.results.queries.forEach(query => {
                                let result_li = document.createElement('li');
                                /* T6.02 — encode the term for the URL (a "&" or "+" in a suggestion used to truncate/mangle the query). */
                                /* Audit D2 (11 Oct 2026): type=product on the suggestion link (written as &amp; because this string is parsed as HTML). */
                                result_li.innerHTML = `<a href="/search?q=${encodeURIComponent(query.text)}&amp;type=product">${query.text}<span class="count"></span></a>`;
                                _.selector.search_suggestion_products.querySelector('ul').append(result_li);
                            });
                        }
                        if(suggestions.resources.results.collections.length > 0) {
                            _.selector.search_suggestion_collections.classList.add('active');
                            _.selector.search_suggestion_collections.querySelector('ul').innerHTML = '';
                            suggestions.resources.results.collections.forEach(collection => {
                                let result_li = document.createElement('li');
                                result_li.innerHTML = `<a href="${collection.url}">${collection.title}<span class="count"></span></a>`;
                                _.selector.search_suggestion_collections.querySelector('ul').append(result_li);
                            })
                        }
                        if(suggestions.resources.results.pages.length > 0) {
                            _.selector.search_suggestion_pages.classList.add('active');
                            _.selector.search_suggestion_pages.querySelector('ul').innerHTML = '';
                            suggestions.resources.results.pages.forEach(page => {
                                let result_li = document.createElement('li');
                                result_li.innerHTML = `<a href="${page.url}">${page.title}<span class="count"></span></a>`;
                                _.selector.search_suggestion_pages.querySelector('ul').append(result_li);
                            })
                        }
                        if(suggestions.resources.results.articles.length > 0) {
                            _.selector.search_suggestion_blog_posts.classList.add('active');
                            _.selector.search_suggestion_blog_posts.querySelector('ul').innerHTML = '';
                            suggestions.resources.results.articles.forEach(article => {
                                let result_li = document.createElement('li');
                                result_li.innerHTML = `<a href="${article.url}">${article.title}<span class="count"></span></a>`;
                                _.selector.search_suggestion_blog_posts.querySelector('ul').append(result_li);
                            })
                        }
                        /* Fallback so the "Suggestions" column is never empty while products exist: if
                           Shopify returned no predictive query suggestions (common for longer prefixes
                           like "reap"), fill it with the matching product names instead. These come from
                           suggest.json's own prefix-matched products, so the column updates on every
                           keystroke, mirroring the product grid. */
                        if(suggestions.resources.results.queries.length === 0 && suggestions.resources.results.products.length > 0) {
                            _.selector.pre_added_suggestion_products.classList.remove('active');
                            _.selector.search_suggestion_products.classList.add('active');
                            _.selector.search_suggestion_products.querySelector('ul').innerHTML = '';
                            suggestions.resources.results.products.forEach(product => {
                                let result_li = document.createElement('li');
                                result_li.innerHTML = `<a href="${product.url}">${product.title}<span class="count"></span></a>`;
                                _.selector.search_suggestion_products.querySelector('ul').append(result_li);
                            });
                        }
                    } else {
                        _.selector.pre_added_suggestion_products.classList.add('active');
                        _.selector.search_suggestion_products.classList.remove('active');
                        _.selector.search_suggestion_products.querySelector('ul').innerHTML = '';
                        _.selector.search_suggestion_collections.classList.remove('active');
                        _.selector.search_suggestion_collections.querySelector('ul').innerHTML = '';
                        _.selector.search_suggestion_pages.classList.remove('active');
                        _.selector.search_suggestion_pages.querySelector('ul').innerHTML = '';
                        _.selector.search_suggestion_blog_posts.classList.remove('active');
                        _.selector.search_suggestion_blog_posts.querySelector('ul').innerHTML = '';
                        _.selector.search_auto_complete.querySelector('ul').innerHTML = '';
                        _.selector.search_auto_complete.classList.remove('active');
                    }
                })
                .catch(error => {
                    if (error.name !== 'AbortError' && myReq === _.state.reqSeq) console.error('Fetch request failed:', error);
                });
            } else {
                _.selector.pre_added_suggestion_products.classList.add('active');
                _.selector.search_suggestion_products.classList.remove('active');
                _.selector.search_suggestion_products.querySelector('ul').innerHTML = '';
                _.selector.search_suggestion_collections.classList.remove('active');
                _.selector.search_suggestion_collections.querySelector('ul').innerHTML = '';
                _.selector.search_suggestion_pages.classList.remove('active');
                _.selector.search_suggestion_pages.querySelector('ul').innerHTML = '';
                _.selector.search_suggestion_blog_posts.classList.remove('active');
                _.selector.search_suggestion_blog_posts.querySelector('ul').innerHTML = '';
                _.selector.search_auto_complete.querySelector('ul').innerHTML = '';
                _.selector.search_auto_complete.classList.remove('active');
            }
        })();
    }
    FilterSearch = new FilterSearch;
}
FilterSearch();
